import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { RespCustomerContract_CompanyInContact } from '../../../../item/ItemCustomerContract';

export function ItemCompanyInContact({ item, action, isEdit = true }) {
  const [companyInContact, setACompanyInContact] = useState("")
  const [companyNameInContact, setCompanyNameInContact] = useState("")
  const [companyNameInContactGUI, setCompanyNameInContactGUI] = useState("")

  useEffect(() => {
    if (item !== undefined && companyInContact !== item) {
      setACompanyInContact(item)
      setCompanyNameInContact(item.companyNameInContact)
      setCompanyNameInContactGUI(item.companyNameInContactGUI)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      var mRespCustomerContract_CompanyInContact = new RespCustomerContract_CompanyInContact({
        companyNameInContact,
        companyNameInContactGUI,
      })
      action(mRespCustomerContract_CompanyInContact)
    }
  }, [companyNameInContact, companyNameInContactGUI, action])


  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>代表乙方簽約之公司</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleInput title={"簽約公司名稱"} val={companyNameInContact} action={setCompanyNameInContact} placeholder={"XXX股份有限公司"} />
            : <SingleText title={"簽約公司名稱"} val={companyNameInContact} />
          }
          {isEdit ?
            <SingleInput title={"統編"} val={companyNameInContactGUI} action={setCompanyNameInContactGUI} placeholder={"28176129"} />
            : <SingleText title={"統編"} val={companyNameInContactGUI} />
          }
        </div>
      </div>
    </>
  )
}